import "./csp"; // must be first: sets __webpack_nonce__ before any chunk loads
import "./extensions";

import { CacheProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { emotionCache } from "./csp";
import store from "app/Store";
import ConfigSuspense from "features/configuration/ConfigSuspense";
import Localization from "features/locale/Localization";
import LocalizedRouter from "features/locale/LocalizedRouter";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";
import reportWebVitals from 'reportWebVitals';
import CustomThemeProvider from "themes/CustomThemeProvider";
import { CsrfProvider } from "./app/hooks";

const rootElement = document.getElementById("root");

const render = () => {
  const App = require("./app/App").default;
  ReactDOM.render(
    <CacheProvider value={emotionCache}>
      <Provider store={store}>
        <ConfigSuspense>
          <CustomThemeProvider>
            <CssBaseline />
            <Localization>
              <LocalizedRouter RouterComponent={BrowserRouter}>
                <CsrfProvider>
                  <App />
                </CsrfProvider>
              </LocalizedRouter>
            </Localization>
          </CustomThemeProvider>
        </ConfigSuspense>
      </Provider>
    </CacheProvider>,
    rootElement
  );
};

render();

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./app/App", render);
}

serviceWorkerRegistration.register();
reportWebVitals();
